import React from 'react';
import './detailMidBoxJob.css'

const DetailMidBoxJob = ({ title, data }) => {
  return (
    <div className='detail-mid-job__container'>
      <h3>{title}</h3>
      <div className='detail-mid-job__description-container'>
        <p>{data}</p>
      </div>
    </div>
  );
};

export default DetailMidBoxJob;